import { render, staticRenderFns } from "./TabsSection.vue?vue&type=template&id=392e1637&"
import script from "./TabsSection.vue?vue&type=script&lang=js&"
export * from "./TabsSection.vue?vue&type=script&lang=js&"
import style0 from "./TabsSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TabsSection.vue"
export default component.exports